import { Component, OnInit } from "@angular/core";
import { TicketpaymentService } from "../ticket-payment/ticketpayment.service";
import { ActivatedRoute } from "@angular/router";
import { ManagePayersListModalComponent } from "@foh/publicpages/ticket-management/manage-payers-list-modal/manage-payers-list-modal.component";
import {
  NgbModal,
  ModalDismissReasons,
  NgbActiveModal
} from "@ng-bootstrap/ng-bootstrap";
import {
  confirmWithHtml,
  success,error
} from "@foh/shared/data/sweet-alerts";

@Component({
  selector: "app-ticket-management",
  templateUrl: "./ticket-management.component.html",
  styleUrls: ["./ticket-management.component.scss"]
})
export class TicketManagementComponent implements OnInit {
  choosedMethod: any = null;
  currentStep: string;
  invalidUrlMsg: string;
  routeObs$: any;
  token: any;
  list: any = [];
  availableList: any = [];
  ticketsCats: any;
  venue: any;
  totalTickets: any;
  currentSelectedPayer: any = null;
  currentChoosenTickets: any = null;
  groups: any = [];
  groupsWithLink: any = [];
  foundBefore: boolean = false;
  loading: boolean = true;
  invalidUrlError: boolean = false;
  createLoading: boolean = false;
  deleteLoading: boolean = false;
  imageSrc: null;
  constructor(
    private activeRoute: ActivatedRoute,
    private ticketpaymentService: TicketpaymentService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.routeObs$ = this.activeRoute.params.subscribe(params => {
      this.token = params["token"];
      this.retrieve();
    });
  }

  retrieve() {
    this.ticketpaymentService
      .retrieveTickets({ token: this.token })
      .subscribe((response: any) => {
        this.loading = false;
        this.processRetrieveTicketResponse(response);

      },(error:any)=>
      {
        this.loading = false;
        this.invalidUrlError=true;
        this.invalidUrlMsg = error.error.message;

      });
  }

  processRetrieveTicketResponse(response){
    if (response.foundBefore) {
      this.foundBefore = true;
      return this.initStep4Directly(response);
    }
    this.showStep1();
    this.list = response.list;
    this.venue = response.venue;
    this.ticketsCats = response.ticketsCats;
    this.injectTicketCats();
    this.totalTickets = this.list.length;
  }

  initStep4Directly(response) {
    this.prepareLinks(response);
    this.showLinksStep();
  }

  prepareLinks(response) {
    this.groupsWithLink = [];
    for (var i = 0; i < response.list.length; i++) {
      var payer = this.getTicketById(
        response.list[i].ticket_id,
        response.tickets
      );
      var paysFor = this.getPaysFor(response.list[i].paysfor, response.tickets);
      var link = response.paymentLink + response.list[i].referencecode;
      this.groupsWithLink.push({
        payer: payer,
        paysFor: paysFor,
        link: link
      });
    }
  }

  getTicketById(id, ticketsList) {
    for (var i = 0; i < ticketsList.length; i++) {
      if (ticketsList[i].id == id) {
        return ticketsList[i];
      }
    }
    return false;
  }

  getPaysFor(paysFor, ticketsList) {
    var finalArray = [];
    var arrayOfPaysFor = paysFor.split(";");
    for (var i = 0; i < arrayOfPaysFor.length; i++) {
      var ticket = this.getTicketById(arrayOfPaysFor[i], ticketsList);
      finalArray.push(ticket);
    }
    return finalArray;
  }

  setPaymentType(type) {
    this.choosedMethod = type;

    if (type == "group") {
      this.resetAll();
      this.refreshAvailableTicketsList();
      this.showSplitStep();
    } else {
      if (type == "all") {
        this.createFullList();
      }
      if (type == "seperate") {
        this.createIndividualList();
      }
      this.showPreviewStep();
    }
  }

  resetToStep1() {
    this.resetAll();
    this.showStep1();
  }

  backOneStepFromConfirmation() {
    if (this.choosedMethod == "group") {
      this.showSplitStep();
      return;
    }
    this.showStep1();
    return;
  }

  showStep1() {
    this.currentStep = "1";
  }

  showSplitStep() {
    this.currentStep = "2";
  }
  showPreviewStep() {
    this.currentStep = "3";
  }
  showLinksStep() {
    this.currentStep = "4";
  }

  injectTicketCats() {
    for (var i = 0; i < this.list.length; i++) {
      var ticketCat = this.getTicketCatById(this.list[i].ticketcat_id);
      this.list[i].ticketName = ticketCat.name;
      this.list[i].ticketPrice = ticketCat.price;
      this.list[i].selected = true;
    }
  }
  getTicketCatById(id) {
    for (var i = 0; i < this.ticketsCats.length; i++) {
      if (this.ticketsCats[i].id == id) {
        return this.ticketsCats[i];
      }
    }
    return null;
  }

  resetCurrentPayer() {
    this.currentSelectedPayer = null;
    this.currentChoosenTickets = [];
  }

  selectCurrentPayer(ticket) {
    this.currentSelectedPayer = ticket;
    this.openGroupSelectModal();
  }

  saveGroup(ids) {
    var injectedArray = this.detailedArrayOfPaysFor(ids);

    var total = this.totalForGroup(injectedArray);

    this.groups.push({
      payer: this.currentSelectedPayer,
      paysFor: ids,
      payForInjected: injectedArray,
      total: total
    });

    this.resetCurrentPayer();
    this.refreshAvailableTicketsList();
  }

  onRemoveGroup(index) {
    this.groups.splice(index, 1);
    this.refreshAvailableTicketsList();
  }

  refreshAvailableTicketsList() {
    this.availableList = [];
    for (var i = 0; i < this.list.length; i++) {
      if (this.isTicketAddedBefore(this.list[i].id)) {
        continue;
      }
      this.availableList.push(this.list[i]);
    }
  }

  isTicketAddedBefore(ticketId) {
    for (var i = 0; i < this.groups.length; i++) {
      if (this.groups[i].paysFor.indexOf(ticketId) > -1) {
        return true;
      }
    }
    return false;
  }

  detailedArrayOfPaysFor(ids) {
    var array = [];
    for (var j = 0; j < ids.length; j++) {
      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i].id == ids[j]) {
          array.push(this.list[i]);
        }
      }
    }
    return array;
  }

  totalForGroup(array) {
    var total = 0;
    for (var i = 0; i < array.length; i++) {
      total += array[i].ticketPrice;
    }
    return total;
  }

  createFullList() {
    this.groups = [];
    var payFor = [];
    var payForInjected = [];
    var total = 0;
    for (var i = 0; i < this.list.length; i++) {
      payFor.push(this.list[i].id);
      payForInjected.push(this.list[i]);
      total += this.list[i].ticketPrice;
    }
    this.groups.push({
      payer: this.list[0],
      paysFor: payFor,
      payForInjected: payForInjected,
      total: total
    });
    this.resetCurrentPayer();
    this.refreshAvailableTicketsList();
  }

  createIndividualList() {
    this.groups = [];

    for (var i = 0; i < this.list.length; i++) {
      var payFor = [];
      var payForInjected = [];
      payFor.push(this.list[i].id);
      payForInjected.push(this.list[i]);
      this.groups.push({
        payer: this.list[i],
        paysFor: payFor,
        payForInjected: payForInjected,
        total: this.list[i].ticketPrice
      });
    }
    this.resetCurrentPayer();
    this.refreshAvailableTicketsList();
  }

  generateLinks() {
    this.createLoading = true;
    var finalGroup = this.prepareGroupObjectForSubmit();
    this.ticketpaymentService
      .createTicketsGroup({ token: this.token, group: finalGroup })
      .subscribe((response: any) => {
        this.createLoading = false;
        this.foundBefore = true;
        this.initStep4Directly(response);
      },(error)=>
      {
        this.createLoading = false;
      });
  }

  prepareGroupObjectForSubmit() {
    var array = [];
    for (var i = 0; i < this.groups.length; i++) {
      array.push({
        payerid: this.groups[i].payer.id,
        paysfor: this.groups[i].paysFor
      });
    }
    return array;
  }

  resetAll() {
    this.groups = [];
    this.resetCurrentPayer();
  }

  openGroupSelectModal() {
    const modalRef = this.modalService.open(ManagePayersListModalComponent, {
      windowClass: "foh-modal"
    });
    modalRef.componentInstance.currentSelectedPayer = this.currentSelectedPayer;
    modalRef.componentInstance.availableList = this.availableList;
    setTimeout(() => {
      modalRef.componentInstance.recalculateTotal();
    }, 50);
    modalRef.componentInstance.save.subscribe(ids => {
      this.saveGroup(ids);
      modalRef.componentInstance.activeModal.dismiss("Saved");
    });
  }

  confirmDeleteGroup(){
    confirmWithHtml(
      "Reset & Delete Created Group",
      "Are you sure you want to reset & re-create the groups? This will invalidate created payment links"
    ).then(confirm => {
      if (confirm.value == true) {
        this.deleteGroup();
      }
    });
  }

  deleteGroup(){
    this.deleteLoading = true;
    this.ticketpaymentService
      .deleteTicketsGroup({ token: this.token })
      .subscribe((response: any) => {
        this.deleteLoading = false;
        success(
          "Created Groups are deleted",
          "Please create new groups in order to generate new payment links."
        );
        this.processRetrieveTicketResponse(response);
        },(error)=>
      {
        this.deleteLoading = false;
      });
  }
}
